import React from "react";

const StatCard = ({ title, value }) => {
    return (
        <div className="w-full md:w-1/4 md:hover:scale-150 flex flex-col bg-rs-azul p-4 rounded-lg shadow-lg shadow-rs-rojo text-center">
            <strong className="text-white">{title}</strong>
            <p className="text-white">{value}</p>
        </div>
    );
};

export default StatCard;